import { render } from "./SupportTicketButton.vue?vue&type=template&id=5ad23db6&scoped=true"
import script from "./SupportTicketButton.vue?vue&type=script&lang=js"
export * from "./SupportTicketButton.vue?vue&type=script&lang=js"

import "./SupportTicketButton.vue?vue&type=style&index=0&id=5ad23db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad23db6"]])

export default __exports__